import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import clsx from 'clsx';
import FooterItems from './FooterItems';
const FooterSection = (props) => {
    const { section, os, platform, options } = props;
    return (_jsx(React.Fragment, { children: Object.keys(section).map((subSection, listIndex) => (_jsx("div", { className: clsx('iv-col-span-6'), children: section[subSection].map((subSectionItem, sectionIndex) => (_jsx(FooterItems, { footerItems: subSectionItem, index: sectionIndex, os: os, options: options, platform: platform }, subSectionItem.title))) }, listIndex))) }));
};
export default FooterSection;
